var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@hn-ui/tooltips';
import { memo } from 'react';
import { cutText } from '../../utils/text';
var DEFAULT_NAME_MAX_LENGTH = 10;
var StudentName = memo(function (_a) {
    var name = _a.name, renderName = _a.renderName, _b = _a.maxLength, maxLength = _b === void 0 ? DEFAULT_NAME_MAX_LENGTH : _b, _c = _a.tooltipProps, tooltipProps = _c === void 0 ? {} : _c;
    var croppedName = cutText(name, maxLength);
    return (_jsx(Tooltip, __assign({ content: name, maxWidth: 'none', mouseOnly: true, interactive: name.length > maxLength }, tooltipProps, { children: renderName(croppedName) }), void 0));
});
export { StudentName };
